import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// src
import Landing from './cmp/Landing.js';
import Login from './cmp/Authentication/Login.js';
import Home from './cmp/Home.js';
import PublicRoute from './cmp/Routing/PublicRoute.js';
import PrivateRoute from './cmp/Routing/PrivateRoute.js';
import * as routes from './routes/routes_production.js';
import './App.css';
import ChangePWD from './cmp/Authentication/ChangePWD.js';

class App extends React.Component {
  
  constructor() {
  	super();
		this.state = { auth: null, isLoading: true };
    
    this.isAuthenticated = this.isAuthenticated.bind(this);
	}

  componentDidMount() {    
    let serialeOperatore = this.isAuthenticated();    
    if(serialeOperatore) {
      this.setState({ auth: serialeOperatore, isLoading: false });   
    } else {
      this.setState({ auth: null, isLoading: false });
    }
  }

  render() {
  	const { isLoading } = this.state;

    return (      
      !isLoading && 
      <div className="App">
      	<Router>
          <Switch>
      		  <Route exact path={routes.LANDING} 
              component={() => <Landing 
                auth={this.isAuthenticated} />} />
            
            <PublicRoute exact path={routes.LOGIN} component={Login} 
                auth={this.isAuthenticated} /> 

            <PublicRoute exact path={routes.CHANGE_PWD} component={ChangePWD} 
                auth={this.isAuthenticated} />

            <PrivateRoute path={routes.HOME} component={Home} 
                auth={this.isAuthenticated} /> 

            <Route component={()=>(<div>not found</div>)} />                    
          </Switch>
      	</Router> 
      </div>
    );
  }

  isAuthenticated() {    
    return localStorage.getItem('serialeOperatore');
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js